import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import Table from "react-bootstrap/Table";
import cogoToast from "@successtar/cogo-toast";

function EditAgent() {
  const [formData, setFormData] = useState({
    agentSelected: "",
    agents: "",
    editAgentData: false,
    agentData: null,
    agentFirstName: "",
    agentLastName: "",
    agentEmail: "",
    agentTelephone: "",
    agentResidentState: "",
    agentAddress: "",
    agentDedicatedCSR: "",
    agentSupervisor: ""
  });

  useEffect(() => {
    API.getAgents()
      .then((res) => {
        setFormData((prev) => ({ ...prev, agents: res.data }));
      })
      .catch((err) => console.log(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const populateAgentData = (event) => {
    event.preventDefault();

    if (!formData.agentSelected) {
      alert("Need to select an agent!");
      return;
    }

    API.findAgent(formData.agentSelected).then((res) => {
      setFormData((prev) => ({
        ...prev,
        agentData: res.data,
        agentFirstName: res.data.firstName,
        agentLastName: res.data.lastName,
        agentEmail: res.data.email,
        agentTelephone: res.data.telephone,
        agentResidentState: res.data.residentState,
        agentAddress: res.data.address,
        agentDedicatedCSR: res.data.dedicatedCSR,
        agentSupervisor: res.data.supervisor
      }));
    });
  };

  const editAgentData = (e) => {
    e.preventDefault();
    setFormData((prev) => ({
      ...prev,
      editAgentData: !prev.editAgentData
    }));
  };

  const saveAgentData = (e) => {
    e.preventDefault();

    const updatedData = {
      firstName: formData.agentFirstName,
      lastName: formData.agentLastName,
      email: formData.agentEmail,
      telephone: formData.agentTelephone,
      residentState: formData.agentResidentState,
      address: formData.agentAddress,
      dedicatedCSR: formData.agentDedicatedCSR,
      supervisor: formData.agentSupervisor
    };

    API.updateAgent(formData.agentData._id, updatedData)
      .then((res) => {
        cogoToast.success("Agent has been updated");
        setFormData((prev) => ({
          ...prev,
          agentData: res.data,
          agentFirstName: res.data.firstName,
          agentLastName: res.data.lastName,
          agentEmail: res.data.email,
          agentTelephone: res.data.telephone,
          agentResidentState: res.data.residentState,
          agentAddress: res.data.address,
          agentDedicatedCSR: res.data.dedicatedCSR,
          agentSupervisor: res.data.supervisor,
          editAgentData: false
        }));
      })
      .catch((err) => console.log(err));
  };

  const cellStyle = {
    textAlign: "center",
    backgroundColor: "black",
    color: "white",
    fontWeight: "bold"
  };

  return (
    <div>
      <div className="card-body" style={{ textAlign: "center" }}>
        <h3>Edit Agent</h3>
        <p>Select the Agent to Edit below</p>
        <form>
          <input
            list="agents"
            value={formData.agentSelected}
            name="agentSelected"
            onChange={handleInputChange}
          />
          {formData.agents ? (
            <datalist id="agents">
              {formData.agents.map((agent) => (
                <option key={agent._id} value={agent._id}>
                  {agent.firstName} {agent.lastName}
                </option>
              ))}
            </datalist>
          ) : null}
          <button className="btn btn-sm btn-info" onClick={populateAgentData}>
            Search
          </button>
        </form>
        {formData.agentData ? (
          <>
            <div className="card">
              <div className="card-header">
                <h4>Agent Data</h4>
              </div>
              <div className="card-body">
                {formData.editAgentData ? (
                  <form>
                    <Table bordered hover style={{ backgroundColor: "white" }}>
                      <tbody>
                        <tr>
                          <th>Question</th>
                          <th>Input</th>
                        </tr>
                        <tr>
                          <td style={cellStyle}>First name</td>
                          <td>
                            <input
                              type="text"
                              value={formData.agentFirstName}
                              onChange={handleInputChange}
                              name="agentFirstName"
                              placeholder="First Name"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Last name</td>
                          <td>
                            <input
                              type="text"
                              value={formData.agentLastName}
                              onChange={handleInputChange}
                              name="agentLastName"
                              placeholder="Last Name"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Email</td>
                          <td>
                            <input
                              type="text"
                              value={formData.agentEmail}
                              onChange={handleInputChange}
                              name="agentEmail"
                              placeholder="E-mail address"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Telephone</td>
                          <td>
                            <input
                              type="text"
                              value={formData.agentTelephone}
                              onChange={handleInputChange}
                              name="agentTelephone"
                              placeholder="Telephone number"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Address</td>
                          <td>
                            <input
                              type="text"
                              value={formData.agentAddress}
                              onChange={handleInputChange}
                              name="agentAddress"
                              placeholder="Address"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Resident State</td>
                          <td>
                            <input
                              type="text"
                              value={formData.agentResidentState}
                              onChange={handleInputChange}
                              name="agentResidentState"
                              placeholder="Resident State"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Dedicated CSR</td>
                          <td>
                            {formData.agents ? (
                              <div>
                                <select
                                  id="protegeDropMenu"
                                  value={formData.agentDedicatedCSR}
                                  onChange={handleInputChange}
                                  name="agentDedicatedCSR"
                                >
                                  <option value="">--Select an Agent--</option>
                                  {formData.agents.map((agent) => (
                                    <option key={agent._id} value={agent._id}>
                                      {agent.firstName} {agent.lastName}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            ) : (
                              <div>No agents yet</div>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td style={cellStyle}>Supervisor</td>
                          <td>
                            {formData.agents ? (
                              <div>
                                <select
                                  id="protegeDropMenu"
                                  value={formData.agentSupervisor}
                                  onChange={handleInputChange}
                                  name="agentSupervisor"
                                >
                                  <option value="">--Select an Agent--</option>
                                  {formData.agents.map((agent) => (
                                    <option key={agent._id} value={agent._id}>
                                      {agent.firstName} {agent.lastName}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            ) : (
                              <div>No agents yet</div>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>
                            <button
                              style={{
                                color: "white",
                                fontSize: "20px",
                                boxShadow: "0px 0px 1px 1px black",
                                backgroundImage: "linear-gradient(147deg, black 90%, white 0%)",
                                padding: "5px 20px 5px 20px",
                                borderRadius: "5px"
                              }}
                              onClick={saveAgentData}
                            >
                              Submit
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </form>
                ) : (
                  <div>
                    <p>
                      Agent Name: {formData.agentData.firstName + " " + formData.agentData.lastName}
                    </p>
                    <p>Agent Phone: {formData.agentData.telephone}</p>
                    <p>Agent Email: {formData.agentData.email}</p>
                    <button onClick={editAgentData}>Edit</button>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}

export default EditAgent;
